import * as types from './types'

export default {
  [types.OVERDUE_SIGNATURES]: state => {
    return state.overdueSignatures
  },
  [types.INACTIVE_PN_CONTRACTS]: state => {
    return state.inactivePnContracts
  },
  [types.INACTIVE_PN_CUSTOMERS]: state => {
    return state.inactivePnCustomers
  },
  [types.CONSULTANT_TERMINATIONS]: state => {
    return state.consultantTerminations
  },
  [types.CONTRACTS_AND_CUSTOMERS]: state => {
    return state.contractAndCustomers
  },
  [types.EPS_SUBSCRIPTIONS_AND_SOLUTIONS]: state => {
    return state.epsSubscriptionsAndSolutions
  }
}
